import React from 'react';
import Step from "components/MainApp/atoms/Wizard/Step";
import Icon from "components/MainApp/atoms/Icon/icon"

import styles from "./styles.module.scss";
import i18n from 'i18n';

export class AddConfigTagStepFour extends React.Component {

  render() {
    const { configTagInfo, handleFinish } = this.props;

    const stepContent = (
      <form onSubmit={handleFinish}>

        <div className={styles["add-config-tag-wizard-step-four-content"]}>
          <h1 className={styles["add-config-tag-confirmation-main-title"]}>{i18n.t("check.data")}</h1>
          {configTagInfo && configTagInfo.map((info, i) => {
            return <div className={styles["config-tag-confirmation-wrapper"]} key={i}>
              <div className={styles["config-tag-confirmation-header"]}>
                <h2 className={styles["config-tag-confirmation-title"]}>{info.step}</h2>
                <div onClick={info.handleClick}><Icon name="edit2" height={20} width={20} fill={'#3C7AF5'} /></div>
              </div>
              <div className={styles["config-tag-confirmation-content"]}>
                {info.data.map((d, i) => {
                  return <div key={i}>
                    {d.title && <div key={i} className={styles["config-tag-confirmation-key"]}>{d.title}</div>}
                    <div key={i} className={styles["config-tag-confirmation-item"]}>{d.value}</div>
                  </div>
                })}
              </div>
            </div>
          })}

          <div className={styles["add-config-tag-wizard-step-four-action-wrapper"]}>
            <button type="submit" className={styles["add-config-tag-wizard-step-four-action-button"]}>
              {i18n.t("confirm")}
            </button>
          </div>
        </div>
      </form>
    );

    return (
      <div className={styles["add-config-tag-wizard-step-four-container"]}>
        <Step content={stepContent}></Step>
      </div>
    );
  }
}

export default AddConfigTagStepFour;
